export default __webpack_public_path__ + "static/media/wait-tred1.6f5bbfe9.jpeg";